(() => {
  const selector = {
    extraImagesHandler: '.js-open-gallery',
    slider: '.productGallery__slider',
    extraImage: '.productGallery__sliderExtraImages .productGallery__contentItem',
    sliderCounterValue: '.productGallery__sliderCounterValue',
  };
  const slickSettings = {
    infinite: false,
    dots: false,
    arrows: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: 'unslick'
      },
    ],
  };
  const hiddenImages = document.querySelectorAll('.productGallery__sliderImageWrapper.hide-image');
  const extraImagesHandler = document.querySelector(selector.extraImagesHandler);
  const extraImages = document.querySelectorAll(selector.extraImage);
  const sliderCounterValue = document.querySelector(selector.sliderCounterValue);

  function zoomExtraImages() {
    extraImages[0].querySelector('button').click();
  }

  if (extraImagesHandler) extraImagesHandler.addEventListener('click', zoomExtraImages);

  hiddenImages.forEach((img) => {
    img.classList.remove('hide-image');
  });

  $(selector.slider).slick(slickSettings);

  window.addEventListener('resize', () => {
    $(selector.slider).slick('resize');
  });

  if (sliderCounterValue) {
    $(selector.slider).on('afterChange', function(event, slick, currentSlide) {
      sliderCounterValue.innerHTML = currentSlide + 1;
    });
  }
})();
